<template>
  <div>
    <div v-for="badge in badgeTags" :key="badge" class="product-badge">
      {{ getBadgeText(badge) }} 
    </div>
  </div>
</template>


<script>
  export default {
    name: 'ProductBadges',
    props: {
      productTags: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    mounted() {
      // console.log('Received product tags: ', this.productTags);
    },
    computed: {
      badgeTags() {
        // console.log('this.productTags', this.productTags);
        const filteredTags = this.productTags
          .filter(tag => tag.startsWith('badge:'))
          .filter(tag => this.getBadgeText(tag));
        // console.log('filteredTags', filteredTags);
        return filteredTags;
      },
    },
    methods: {
      getBadgeText(badgeKey) {
        const formattedBadge = badgeKey.replace('badge:', '').trim();
        // console.log(`Retrieving badge text for key: ${formattedBadge}`);

        const badgeText = window.badgeTextFromKey(formattedBadge);
        // console.log(`Badge text retrieved: ${badgeText}`);

        return badgeText || null;
      },
    },
  }
</script>
